import React from 'react';
import {
    Nav,
    NavLink,
    NavMenu,
    NavBtn,
    NavBtnLink,
    DropdownButton,
    DropdownContainer,
    DropdownContent,
    DropdownLink
} from './NavbarElements';
import logo from "../images/Logo.png";
import PasswordReset from './PasswordReset';


const Navbar = ({ setAuth, setAdm, authenticationStatus, adminStatus }) => {
    return (
        <>
            <Nav>
                <div style={{ display: 'flex', alignItems: 'center', zIndex: 100,}}>
                    <NavLink to="/">
                        <img src={logo} alt="logo" width="50" height="50" data-no-alaska="true" />
                    </NavLink>
                    <h2 className="mb-0">BCA</h2>
                    <div>
                        <NavMenu>
                            {!authenticationStatus && loggedOutBar}
                            {authenticationStatus && adminStatus === 0 && adminZeroBar}
                            {authenticationStatus && adminStatus === 1 && adminOneBar}
                            {authenticationStatus && adminStatus === 2 && adminTwoBar}
                            {/* Second Nav */}
                            {/* <NavBtnLink to='/sign-in'>Sign In</NavBtnLink> */}
                        </NavMenu>
                    </div>
                </div>

                {/* only have 1 of these */}
                {!authenticationStatus ?
                    <NavMenu>
                        <NavBtn>
                            <NavBtnLink to='/SignIn'>Worker Sign In</NavBtnLink>
                        </NavBtn>
                    </NavMenu>
                    :
                    <NavMenu>
                        <NavBtn>
                            <NavBtnLink to='/' onClick={() => { localStorage.removeItem("token"); setAuth(false); setAdm(0); }}>Worker Sign Out</NavBtnLink>
                        </NavBtn>
                        <NavBtn><PasswordReset id_space={2} /></NavBtn>
                    </NavMenu>
                }
            </Nav>
        </>
    );
};

export default Navbar;

const loggedOutBar = (<>
    <DropdownContainer>
        <DropdownButton label="Our asfsdServices" to="/OurServices">Our Services</DropdownButton>
        <DropdownContent>
            <DropdownLink to="/OurServices/CommunityOutdoorAccess">Community / Outdoor Access</DropdownLink>
            <DropdownLink to="/OurServices/InHomeSupport">In Home Support</DropdownLink>
            <DropdownLink to="/OurServices/Respite">Respite</DropdownLink>
            <DropdownLink to="/OurServices/AccessibleEats">Accessible Eats</DropdownLink>
            <DropdownLink to="/OurServices/TuesdaySocial">Tuesday Social</DropdownLink>
            <DropdownLink to="/OurServices/NeuroPathways">Neuro Pathways</DropdownLink>
            <DropdownLink to="/OurServices/Crafternoon">Crafternoon</DropdownLink>
            <DropdownLink to="/OurServices/TacticalMinds">Tactical Minds</DropdownLink>
        </DropdownContent>
    </DropdownContainer>
    <NavLink to='/AboutUs'>
        About us
    </NavLink>
    <NavLink to='/ContactUs'>
        Contact Us
    </NavLink>
</>)

const adminZeroBar = <>
    <NavLink to='/InputShift'>
        Add a shift
    </NavLink>
    <NavLink to='/ListShifts'>
        See your shifts
    </NavLink>
</>

const adminOneBar = <>
    <NavLink to='/DirectDB'>View the database</NavLink>
</>

const adminTwoBar = <>
    <NavLink to='/DirectDB'>Manage the database</NavLink>
</>
